export enum BREAKPOINTS {
  tabletMin = 550,
  largeTabletMin = 800,
  laptopMin = 1100,
  smallDesktopMin = 1440,
  desktopMin = 1500,
  largeDesktopMin = 1800,
}
export const QUERIES = {
  tabletAndUp: `@media (min-width: ${BREAKPOINTS.tabletMin}px)`,
  tabletAndDown: `@media (max-width: ${BREAKPOINTS.tabletMin}px)`,
  largeTabletAndUp: `@media (min-width: ${BREAKPOINTS.largeTabletMin}px)`,
  largeTabletAndDown: `@media (max-width: ${BREAKPOINTS.largeTabletMin}px)`,
  laptopAndDown: `@media (max-width: ${BREAKPOINTS.laptopMin - 1}px)`,
  laptopAndUp: `@media (min-width: ${BREAKPOINTS.laptopMin}px)`,
  smallDesktopAndUp: `@media (min-width: ${BREAKPOINTS.smallDesktopMin}px)`,
  desktopAndUp: `@media (min-width: ${BREAKPOINTS.desktopMin}px)`,
  largeDesktopAndUp: `@media (min-width: ${BREAKPOINTS.largeDesktopMin}px)`,
};

export const getDeviceScreenSizeType = (): string => {
  const screenWidth = window?.innerWidth;

  switch (true) {
    case screenWidth < BREAKPOINTS.tabletMin:
      return 'mobile';
    case screenWidth < BREAKPOINTS.laptopMin:
      return 'tablet';
    default:
      return 'desktop';
  }
};
